import { Dayjs } from 'dayjs'

export type CrewDaySchedulePrintOptions = {
  includeConsultations: boolean
  includeTasks: boolean
}

export const defaultPrintOptions: CrewDaySchedulePrintOptions = {
  includeConsultations: true,
  includeTasks: true
}

export const PRINT_OPTIONS_STORAGE_KEY = 'crewDaySchedulePrintOptions'

export const buildPrintFileName = (date: Dayjs) => `crew-schedules-${date.format('YYYY-MM-DD')}.zip`

export const describePrintScope = (options: CrewDaySchedulePrintOptions): string => {
  const extras = [
    options.includeConsultations ? 'consultations' : null,
    options.includeTasks ? 'tasks' : null
  ].filter(Boolean)

  if (extras.length === 0) {
    return 'Jobs only'
  }

  return `Jobs plus ${extras.join(' and ')}`
}

export const sanitisePrintOptions = (value: unknown): CrewDaySchedulePrintOptions => {
  if (value === null || typeof value !== 'object') {
    return defaultPrintOptions
  }

  const candidate = value as Partial<CrewDaySchedulePrintOptions>
  return {
    includeConsultations: typeof candidate.includeConsultations === 'boolean'
      ? candidate.includeConsultations
      : defaultPrintOptions.includeConsultations,
    includeTasks: typeof candidate.includeTasks === 'boolean'
      ? candidate.includeTasks
      : defaultPrintOptions.includeTasks
  }
}
